var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-30 py-40 center"},[_c('b-spinner',{attrs:{"variant":_vm.status === 'Success' ? 'success' : 'danger'}}),_c('p',{class:`mt-5 color-${_vm.status === 'Success' ? 'blue' : 'red'}`},[_vm._v(_vm._s(_vm.status))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }